import type { MediaState, Resolvers } from '../../generated/types';
import {
  MEDIA_STATE_DEFAULT,
  mediaStatesMap,
  sharedMediaStateInitial,
} from './MediaState.state';

export const resolvers: Resolvers = {
  Mutation: {
    addMediaState: (
      _,
      { mediaStateId, mediaStateIndex } = {
        mediaStateId: MEDIA_STATE_DEFAULT,
        mediaStateIndex: 0,
      }
    ) => {
      const id = mediaStateId || crypto.randomUUID();
      const currentMediaState = mediaStatesMap.get(id);
      const newMediaState = [...currentMediaState] as [MediaState];
      const mediaState: MediaState = {
        __typename: `MediaState`,
        ...sharedMediaStateInitial,
        playbackRateAudio: newMediaState[0].playbackRateAudio,
        playbackRateVideo: newMediaState[0].playbackRateVideo,
        customLoop: newMediaState[0].customLoop,
        frameGuide: newMediaState[0].frameGuide,
        isMaskOn: newMediaState[0].isMaskOn,
        cachedFrameGuide: newMediaState[0].cachedFrameGuide,
        isTranscriptionPanelOpen: newMediaState[0].isTranscriptionPanelOpen,
        id,
      };

      if (newMediaState[mediaStateIndex]) {
        newMediaState[mediaStateIndex] = mediaState;
      } else {
        newMediaState.push(mediaState);
      }

      mediaStatesMap.set(id, newMediaState);
      return mediaState;
    },
  },
};
